/**
 * Uplifted from `utils/pos_errors` — WEB/electron half.
 *
 * Holds ONLY this platform's divergent codes (4 unique to it, 4 whose wording differs
 * from the other platform's); the other 919 come from `sharedPosErrorMap`. Spread order
 * matters — the entries below override the shared ones.
 *
 * ⚠️ The other platform's strings are deliberately NOT repeated here, not even in a comment.
 * Metro's dev bundle keeps comments, so a symbol-level bundle grep would report them as a
 * resolution leak that is not real (ledger, session 8 — same rule as `utils/backendErrors`).
 */
import { sharedPosErrorMap } from "./shared";

export * from "./shared";

export const pos_errormap: Record<string, string> = {
  ...sharedPosErrorMap,
  "REST_ERR_EXERCISE_COUPON": "Coupon Redemption failed. Please remove the coupon and retry.",
  "REST_ORDER_IS_NOT_PROCESSED_ON_KDS": "The order can not be closed as the tickets of the order are not marked as done in the KDS,\n    Please mark all the tickets as done in the KDS and try again",
  "CARD_VALIDATION_FAILED": "Card validation failed",
  "REST_CUSTOMER_ID_ALREADY_EXISTS": "Customer ID already exists.",
  "LABEL_ALREADY_ATTACHED": "An open order with the same $ already exists.",
  "UI_ERR_LYLTY_OTP_WRONG": "Incorrect OTP. Re-enter the OTP.",
  "REST_LOYALTY_VERIFY_FAILED": "Invalid OTP. Re-enter the OTP.",
  "REST_SALE_WITH_STALE_CATALOG": "Amount mismatch. You might have a stale catalog. Please logout and login to refresh.",
};

/**
 * Substitutes `args` into a message template at each `$` placeholder.
 *
 * Web splits the template directly. Mobile's copy wraps it in `deepClone` first; both bodies
 * are preserved verbatim rather than unified, because `getPosErrorMessage` is EXPORTED and
 * callable with a non-string `code`, where the two would not behave alike.
 */
export const getPosErrorMessage = (code: any, args: any[] = []) => {
  let module = {
    init: function (this: any) {
      let updatedString = this.reBuildString(code, args);
      return updatedString;
    },
    reBuildString: function (code: any, args: any[]) {
      let string = (code || "").split("$"),
        newStr = "";
      for (let i = 0; i < string.length; i++) {
        newStr += string[i];
        if (args[i]) {
          newStr += args[i];
        }
      }
      return newStr;
    },
  };
  let newString = module.init();
  return newString;
};

/** Maps an error CODE to its message, then fills in `args`. Unknown codes pass through. */
export const getErrorMessage = (code: any, ...args: any[]) => {
  let newString = code;
  if (pos_errormap[code]) {
    newString = getPosErrorMessage(pos_errormap[code], args);
  }
  return newString;
};
